import React, { useState } from 'react';
import { Link2, Check, MessageCircle, Linkedin, Facebook } from 'lucide-react';

// Shares the preview-friendly ".html" URL so WhatsApp/LinkedIn/Facebook unfurl
// the correct per-page Open Graph banner (Emergent static hosting only serves
// exact-file URLs to non-JS crawlers, not the clean SPA route).
export const PressShareBar = ({ slug, title = '' }) => {
  const [copied, setCopied] = useState(false);
  const base = 'https://staymii.com';
  const shareUrl = `${base}/press/${slug}.html`;
  const enc = encodeURIComponent(shareUrl);
  const encTitle = encodeURIComponent(title);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt('Copy this share link:', shareUrl);
    }
  };

  const btn = 'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors';

  return (
    <div className="flex flex-wrap items-center gap-2 mb-6" data-testid="press-share-bar">
      <span className="text-xs font-semibold text-slate-500 mr-1">Share:</span>
      <button onClick={copy} className={`${btn} border-slate-200 text-slate-700 hover:bg-slate-50`} data-testid="press-share-copy">
        {copied ? <><Check className="w-3.5 h-3.5 text-emerald-600" /> Copied!</> : <><Link2 className="w-3.5 h-3.5" /> Copy link</>}
      </button>
      <a href={`https://wa.me/?text=${encTitle}%20${enc}`} target="_blank" rel="noopener noreferrer"
        className={`${btn} border-emerald-200 text-emerald-700 hover:bg-emerald-50`} data-testid="press-share-whatsapp">
        <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
      </a>
      <a href={`https://www.linkedin.com/sharing/share-offsite/?url=${enc}`} target="_blank" rel="noopener noreferrer"
        className={`${btn} border-blue-200 text-blue-700 hover:bg-blue-50`} data-testid="press-share-linkedin">
        <Linkedin className="w-3.5 h-3.5" /> LinkedIn
      </a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${enc}`} target="_blank" rel="noopener noreferrer"
        className={`${btn} border-blue-200 text-blue-700 hover:bg-blue-50`} data-testid="press-share-facebook">
        <Facebook className="w-3.5 h-3.5" /> Facebook
      </a>
    </div>
  );
};

export default PressShareBar;
